import Button from "@mui/material/Button";
import { useAuthStore } from "../../stores/authStore";
import { useNavigate } from "react-router-dom";

export function PaymentWalletButton({
  propertyId,
  onPaymentSuccess = () => {},
  onWindowClosed = () => {},
}) {
  const { auth } = useAuthStore();
  const navigate = useNavigate();
  const openPopup = () => {
    if (!auth.accessToken) {
      auth.reset();
      navigate("/sign-in");
      return;
    }
    const width = 600; // Ancho recomendado (similar a PayPal)
    const height = 700; // Alto recomendado (similar a PayPal)

    // Calcula la posición centrada en la pantalla
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    const url = `${process.env.REACT_APP_WALLET}/buy-estate-property/${propertyId}?isExternal=true`; // URL de tu checkout

    // Abre la ventana emergente
    const walletWindow = window.open(
      url, // URL de tu checkout
      "plusval-wallet",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=no`
    );

    if (!walletWindow) {
      alert("Por favor, habilita los popups en tu navegador.");
    }
  };

  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#a95052",
        lineHeight: { md: "1.2", xl: "1.75" },
        paddingX: { xs: "7px", md: "15px", xl: "20px" },
        "&:hover": { backgroundColor: "#8c3e47" },
      }}
      onClick={openPopup}
    >
      Comprar
    </Button>
  );
}
